import { Container, Row, Col } from "react-bootstrap";
import css from "./TechStack.module.css";
import { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// SVG Icons (inline for performance & control)
const Icons = {
  frontend: (
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M4 5h16M4 12h10M4 19h7" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
  backend: (
    <svg viewBox="0 0 24 24" fill="none">
      <rect
        x="4"
        y="4"
        width="16"
        height="6"
        stroke="currentColor"
        strokeWidth="2"
      />
      <rect
        x="4"
        y="14"
        width="16"
        height="6"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  database: (
    <svg viewBox="0 0 24 24" fill="none">
      <ellipse
        cx="12"
        cy="5"
        rx="8"
        ry="3"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M4 5v7c0 1.7 3.6 3 8 3s8-1.3 8-3V5"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ),
  devops: (
    <svg viewBox="0 0 24 24" fill="none">
      <path d="M4 12h4l2-4 4 8 2-4h4" stroke="currentColor" strokeWidth="2" />
    </svg>
  ),
};

const stack = [
  {
    icon: Icons.frontend,
    title: "Frontend",
    items: ["React.js", "Next.js", "TypeScript", "Tailwind CSS"],
  },
  {
    icon: Icons.backend,
    title: "Backend",
    items: ["Node.js", "Express.js", "Java (Spring Boot)", "REST APIs"],
  },
  {
    icon: Icons.database,
    title: "Database",
    items: ["PostgreSQL", "MySQL", "MongoDB"],
  },
  {
    icon: Icons.devops,
    title: "DevOps & Cloud",
    items: ["Docker", "AWS / DigitalOcean", "CI/CD", "Nginx"],
  },
];

gsap.registerPlugin(ScrollTrigger);

function TechStack() {
  const cardsRef = useRef([]);

  useEffect(() => {
    cardsRef.current.forEach((card, i) => {
      gsap.fromTo(
        card,
        { y: 80, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 85%",
          },
          delay: i * 0.08,
        }
      );
    });
  }, []);

  return (
    <section className={css.techSection}>
      <Container>
        <div className={css.header}>
          <p className={css.badge}>OUR TECHNOLOGY STACK</p>
          <h2 className={css.title}>
            Modern <span>engineering</span> from frontend to infrastructure
          </h2>
          <p className={css.subtitle}>
            We build everything with clean, scalable code —
            <strong> no WordPress, no page builders, no shortcuts.</strong>
          </p>
        </div>

        <Row className={css.grid}>
          {stack.map((group, index) => (
            <Col md={6} lg={3} key={index}>
              <div
                className={css.card}
                ref={(el) => (cardsRef.current[index] = el)}
              >
                <div className={css.icon}>{group.icon}</div>
                <h3 className={css.cardTitle}>{group.title}</h3>
                <ul className={css.list}>
                  {group.items.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </div>
            </Col>
          ))}
        </Row>

        {/* CTA */}
        <div className={css.cta}>
          <p>
            Want to see this stack in action?{" "}
            <a href="/#projects">→ View our work</a>
          </p>
        </div>
      </Container>
    </section>
  );
}

export default TechStack;
